import Link from "next/link"
import type { ComponentProps } from "react"
import { Button } from "@/components/ui/button"
import { cn } from "@/utilities"

const brl = new Intl.NumberFormat("pt-BR", {
  currency: "BRL",
  style: "currency",
})

const toCurrency = (value: number): string => brl.format(value)

interface CartSummarySectionProps extends ComponentProps<"section"> {
  subtotal: number
  discountTotal: number
  total: number
}

export const CartSummarySection = ({
  className,
  subtotal,
  discountTotal,
  total,
  ...props
}: CartSummarySectionProps) => {
  return (
    <section
      className={cn("space-y-3 lg:sticky lg:top-22 lg:self-start", className)}
      {...props}
    >
      <div className='space-y-4 rounded-2xl border bg-white p-5 shadow-xs'>
        <div className='flex items-center justify-between border-border border-b pb-3'>
          <span>Subtotal</span>
          <span className='font-medium'>{toCurrency(subtotal)}</span>
        </div>

        {discountTotal > 0 ? (
          <div className='flex items-center justify-between border-border border-b pb-3'>
            <span>Desconto</span>
            <span className='font-medium text-emerald-700'>
              -{toCurrency(discountTotal)}
            </span>
          </div>
        ) : null}

        <div className='space-y-1 border-border border-b pb-3'>
          <p>Frete: Fast Shop</p>
          <p className='text-sm'>
            Entrega em <span className='font-semibold'>Sao Paulo.</span>
          </p>
        </div>

        <div className='flex items-center justify-between'>
          <span className='font-semibold text-2xl'>Total</span>
          <span className='font-semibold text-2xl text-primary'>
            {toCurrency(total)}
          </span>
        </div>
      </div>

      <Button asChild className='h-12 w-full font-semibold'>
        <Link href='/finalizar-comprar'>Continuar para Finalizacao</Link>
      </Button>
    </section>
  )
}
